module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "id": "dedication"
    }
  }, [_c('p', {
    staticClass: "dedicationText3"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("TO THE MOTHER OF MAJOR “MICK” MANNOCK, V.C."), _c('br'), _vm._v("AND ALL WAR PILOTS WHO DID NOT FAIL IN THEIR DUTY")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52973e97","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KingofAirfighters_dedication.vue
// module id = 72
// module chunks = 0